import { render } from "./EvaluationIndex.vue?vue&type=template&id=b7d01962"
import script from "./EvaluationIndex.vue?vue&type=script&lang=js"
export * from "./EvaluationIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__